import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hidszxqteolsqymeggme.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhpZHN6eHF0ZW9sc3F5bWVnZ21lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk1ODY5NDQsImV4cCI6MjA0NTE2Mjk0NH0.BiMKJEBqGV58Y_8YEXDzXIuoigREo6o-5C2wPVInxfw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
